//
import { RTable } from '@/components/reusable_components/next'

//
import PchPurchaseInvoiceFilters from '@/views/Purchase/PchPurchaseInvoice/filters'
import PchPurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/headers'
import PchPurchaseInvoiceService from '@/services/api/Purchase/PchPurchaseInvoice'

//
export default {
  components: {
    RTable,
  },
  computed: {

    /**
     * 
     */
    tableProps() {
      return {
        filters: PchPurchaseInvoiceFilters.toList(),
        headers: PchPurchaseInvoiceHeaders.toList(),
        service: PchPurchaseInvoiceService.toList(),
      }
    }
  },
  methods: {

    /**
     * 
     */
    onError(error) {
      this.$toast.error(error.error || error.message)
    },

    /**
     * 
     */
    onSuccess(event) {
      this.$toast.success('Factura eliminada exitosamente.')
      this.$refs.table.refresh()
    },

    /**
     * 
     */
    onDelete(event) {
      this.$toast.confirm('¿Confirma la eliminación de la factura seleccionada?', this.$toaster(this, () => this.toDelete(event.item))) 
    },

    /**
     * 
     */
    toDelete(pchPurchaseInvoice) {
      PchPurchaseInvoiceService.delete(pchPurchaseInvoice).then(this.onSuccess).catch(this.onError)
    },
  },
  mounted() {
    this.setTitle('Facturas de compra')
  }
}